import type { PlanEducationIconId } from '../../../../lumpsum/plans-list/timer/shared/planEducationIcons'

/** "An SIP portfolio shaped by your allocation" rows for the SIP Your Plan timer shell. */
export const SIP_YOUR_PLAN_FEATURE_ROWS = [
  {
    iconId: 'disciplinedInvesting' as const satisfies PlanEducationIconId,
    title: 'Disciplined investing approach',
    caption: 'to maintain your ideal allocation'
  },
  {
    iconId: 'clearSipActions' as const satisfies PlanEducationIconId,
    title: 'Clear SIP actions',
    caption: 'telling you which SIPs to start, step up, or pause'
  },
  {
    iconId: 'effortlessSipManagement' as const satisfies PlanEducationIconId,
    title: 'Effortless SIP management',
    caption: 'that adapt as your needs evolve'
  }
] as const
